<template>
  <div>
    <van-field
      v-model="val"
      :label="label"
      :placeholder="placeholder || label"
      :required="required"
      :rules="[{ required: required, message: '请输入' + label }]"
      readonly
      clickable
      is-link
      @click="show = true"
    />
    <van-popup v-model="show" position="bottom" round>
      <van-picker
        :title="'选择 ' + label"
        :columns="actions"
        :value-key="labelAttr"
        show-toolbar
        @confirm="confirm"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    value: {
      type: Number,
      default: 0
    },
    labelAttr: {
      type: String,
      default: 'label'
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      val: this.value && this.namesMap.length > 0 ? this.namesMap[this.value].join('/') : '',
      actions: this.options,
      idsMap: [],
      namesMap: []
    }
  },
  watch: {
    value: function(value) {
      if (value && this.namesMap.length > 0) {
        this.val = this.namesMap[value].join('/')
      }
    },
    options: function(options) {
      this.Utils.generateMapOfIdsArray(options, this.idsMap, this.namesMap)
      this.actions = options
    }
  },
  methods: {
    confirm(values) {
      this.val = values.join('/')
      this.namesMap.forEach((item, index) => {
        if (item.toString() === values.toString()) {
          this.$emit('change', index)
        }
      })
      this.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseCascader.vue